export const carouselInicio = [
    {
        "imagen" : "../assets/imgs/Carousel/2021-07-18.jpg",
    },
    {
        "imagen" : "../assets/imgs/Carousel/Bartolome_3.jpg"
    },
    {
        "imagen" : "../assets/imgs/Carousel/Bartolome_8.jpg"
    },
    {
        "imagen" : "../assets/imgs/Carousel/Bartolome_9.jpg"
    },
    {
        "imagen" : "../assets/imgs/Carousel/Bartolome_10.jpg"
    }
]